// it should be synchronised with SevenSenders\AnalyticsCommonBundle\DoctrineType\Analytics\TrackingPageStatusEnum
export default {
  DRAFT: 'draft',
  PUBLISHED: 'published',
}